import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { AuthProvider } from './lib/auth.jsx';
import { PwaProvider } from './lib/pwa.jsx';
import { LicenseProvider } from './lib/license.jsx';
import './styles/app.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <PwaProvider>
        <AuthProvider>
          {/* LicenseProvider sits inside Auth so it can read user state
              and only poll /api/license/status when the SPA is logged in. */}
          <LicenseProvider>
            <App />
          </LicenseProvider>
        </AuthProvider>
      </PwaProvider>
    </BrowserRouter>
  </StrictMode>
);
